import Vue from 'vue';
import { AxiosPromise } from 'axios';
import {
  DataTableRequest,
  DataTableResponse,
  Response,
  TireStoringContract,
  EnumObject,
  ResponseCodeEnum,
  TireContractDate,
  Term,
} from '@/models';

import { imageService } from '@/services';

// @ts-ignore
import FileSaver from 'file-saver';

class TireStoringContractService extends Vue {
  private ROOT_API = process.env.VUE_APP_ROOT_API + '/webapi/tire-contract';

  public getAll(request: DataTableRequest): AxiosPromise<DataTableResponse<TireStoringContract>> {
    return Vue.axios.get<DataTableResponse<TireStoringContract>>(this.ROOT_API, { params: request });
  }

  public get(id: string): AxiosPromise<Response<TireStoringContract>> {
    return Vue.axios.get<Response<TireStoringContract>>(this.ROOT_API + '/' + id)
      .then((res) => {
        // Gen imageUrl + tire no
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          res.data.data = this.loadImageUrl(res.data.data);
        }
        return res;
      });
  }

  public getBySlipNo(slipNo: string): AxiosPromise<Response<TireStoringContract>> {
    return Vue.axios.get<Response<TireStoringContract>>(this.ROOT_API + '/get-by-slip-no/' + slipNo)
      .then((res) => {
        // Gen imageUrl + tire no
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          res.data.data = this.loadImageUrl(res.data.data);
        }
        return res;
      });
  }

  public create(data: TireStoringContract, isSendMail: boolean, oldContract?: string): AxiosPromise<Response<TireStoringContract>> {
    const request: TireStoringContract = JSON.parse(JSON.stringify(data));
    // if (request.tireType === TireTypeEnum.SUMMER) {
    //   request.winterSeasonInfo = undefined;
    // } else {
    //   request.summerSeasonInfo = undefined;
    // }
    const params = oldContract
      ? { params: { isSendMail: isSendMail, oldContract: oldContract } } 
      : { params: { isSendMail: isSendMail } };
    return Vue.axios.post<Response<TireStoringContract>>(this.ROOT_API, request, params);
  }

  public createMultiContract(listData: TireStoringContract[], isSendMail: boolean): AxiosPromise<Response<TireStoringContract[]>> {
    const listRequest: TireStoringContract[] = JSON.parse(JSON.stringify(listData));
    // listRequest.forEach((request) => {
    //   if (request.tireType === TireTypeEnum.SUMMER) {
    //     request.winterSeasonInfo = undefined;
    //   } else {
    //     request.summerSeasonInfo = undefined;
    //   }
    // });
    return Vue.axios.post<Response<TireStoringContract[]>>(this.ROOT_API + '/create-multi-contract',
      listRequest,
      { params: { isSendMail: isSendMail } });
  }

  public update(data: TireStoringContract, isSwitch: boolean): AxiosPromise<Response<TireStoringContract>> {
    const request: TireStoringContract = JSON.parse(JSON.stringify(data));
    // if (request.tireType === TireTypeEnum.SUMMER) {
    //   request.winterSeasonInfo = undefined;
    // } else {
    //   request.summerSeasonInfo = undefined;
    // }
    return Vue.axios.post<Response<TireStoringContract>>(this.ROOT_API + '/update/' + isSwitch, request);
  }

  public validate(data: TireStoringContract): AxiosPromise<Response<TireStoringContract>> {
    const request: TireStoringContract = JSON.parse(JSON.stringify(data));
    // if (request.tireType === TireTypeEnum.SUMMER) {
    //   request.winterSeasonInfo = undefined;
    // } else {
    //   request.summerSeasonInfo = undefined;
    // }
    return Vue.axios.post<Response<TireStoringContract>>(this.ROOT_API + '/validate', request);
  }

  public getByStatus(request: DataTableRequest, status: number, searchByQrCode: boolean, status02: number = 0)
    : AxiosPromise<DataTableResponse<TireStoringContract>> {
    return Vue.axios.get<DataTableResponse<TireStoringContract>>(this.ROOT_API
      + '/status/' + status + '/qr-code/' + searchByQrCode + '/' + status02, {
      params: request,
    });
  }

  public getByWarehouseAndStatus(request: DataTableRequest, warehouseId: string, status: number, searchByQrCode: boolean)
    : AxiosPromise<DataTableResponse<TireStoringContract>> {
    request.warehouseId = warehouseId;
    request.status = status;
    request.qrCode = searchByQrCode;
    return Vue.axios.get<DataTableResponse<TireStoringContract>>(this.ROOT_API + '/get-by-warehouse-and-status', { params: request });
  }

  public countByDate(contractEndDate: string): AxiosPromise<Response<number>> {
    return Vue.axios.get<Response<number>>(this.ROOT_API + '/count-by-date', {
      params: {
        date: contractEndDate,
      },
    });
  }

  public getByContractEndDate(
      qrCode: boolean,
      request: DataTableRequest): AxiosPromise<DataTableResponse<TireStoringContract>> {
    return Vue.axios.get<Response<number>>(this.ROOT_API
      + '/get-all-pick-up-contract/qr-code/'
      + qrCode, {
      params: request,
    });
  }

  public getContractStatus(): AxiosPromise<Response<EnumObject[]>> {
    return Vue.axios.get<Response<EnumObject[]>>(this.ROOT_API + '/enum/tire-contract-status');
  }

  public getContractPeriod(): AxiosPromise<Response<EnumObject[]>> {
    return Vue.axios.get<Response<EnumObject[]>>(this.ROOT_API + '/enum/tire-contract-period');
  }

  public getContractPeriodByConfigCompany(contractId: String): AxiosPromise<Response<EnumObject[]>> {
    let params = {
      "contractId": contractId
    }
    return Vue.axios.get<Response<EnumObject[]>>(this.ROOT_API + '/enum/tire-contract-period-by-config-company', {params: params});
  }

  public getNumberOfTire(): AxiosPromise<Response<EnumObject[]>> {
    return Vue.axios.get<Response<EnumObject[]>>(this.ROOT_API + '/enum/number-of-tire');
  }

  public getTireType(): AxiosPromise<Response<EnumObject[]>> {
    return Vue.axios.get<Response<EnumObject[]>>(this.ROOT_API + '/enum/tire-type');
  }

  // Not use anymore
  public getTireScratch(): AxiosPromise<Response<EnumObject[]>> {
    return Vue.axios.get<Response<EnumObject[]>>(this.ROOT_API + '/enum/tire-scratch');
  }

  // Not use anymore
  public getTireIrregularWear(): AxiosPromise<Response<EnumObject[]>> {
    return Vue.axios.get<Response<EnumObject[]>>(this.ROOT_API + '/enum/tire-irregular-wear');
  }

  public getTireCondition(): AxiosPromise<Response<EnumObject[]>> {
    return Vue.axios.get<Response<EnumObject[]>>(this.ROOT_API + '/enum/tire-condition');
  }

  public getTireHardness(): AxiosPromise<Response<EnumObject[]>> {
    return Vue.axios.get<Response<EnumObject[]>>(this.ROOT_API + '/enum/tire-hardness');
  }

  public requestPickup(lstContractIds: string[]): AxiosPromise<Response<any>> {
    return Vue.axios.post<Response<any>>(this.ROOT_API + '/request-pickup', lstContractIds);
  }

  public clearPickupDate(contractId: string): AxiosPromise<Response<any>> {
    return Vue.axios.post<Response<any>>(this.ROOT_API + '/clear-pickup/' + contractId);
  }

  public requestDelivery(lstContractIds: string[]): AxiosPromise<Response<any>> {
    return Vue.axios.post<Response<any>>(this.ROOT_API + '/request-delivery', lstContractIds);
  }

  public getContractByListSlipNo(request: DataTableRequest): AxiosPromise<DataTableResponse<TireStoringContract>> {
    return Vue.axios.get<DataTableResponse<TireStoringContract>>(this.ROOT_API + '/get-all-contract-by-slip-no', {
      params: request,
    });
  }

  public inspectionContractComplete(lstContractIds: string[]) {
    return Vue.axios.post(this.ROOT_API + '/inspection-contract', lstContractIds);
  }

  public countContractPickup(contractEndDate: string): AxiosPromise<Response<number>> {
    return Vue.axios.get<Response<number>>(this.ROOT_API + '/count-contract-pickup', {
      params: {
        date: contractEndDate,
      },
    });
  }

  public getPickupContractByContractEndDate(request: DataTableRequest, autoFill: boolean)
    : AxiosPromise<DataTableResponse<TireStoringContract>> {
    return Vue.axios.get<DataTableResponse<TireStoringContract>>(
      this.ROOT_API + '/get-all-pick-up-contract/auto-fill/' + autoFill, {params: request});
  }

  public switchTire(lstContractIds: string[]): AxiosPromise<Response<any>> {
    return Vue.axios.post<Response<any>>(this.ROOT_API + '/switch-tire', lstContractIds);
  }

  public importToWarehouse(lstContractIds: string[], locationId: string): AxiosPromise<Response<any>> {
    return Vue.axios.post<Response<any>>(this.ROOT_API + '/import-to-warehouse', 
      {contractIds: lstContractIds,
        locationId: locationId
      }
      );
  }

  public exportFromWarehouse(lstContractIds: string[]): AxiosPromise<Response<any>> {
    return Vue.axios.post<Response<any>>(this.ROOT_API + '/export-from-warehouse', lstContractIds);
  }

  public setContractCompleted(lstContractIds: string[]): AxiosPromise<Response<any>> {
    return Vue.axios.post<Response<any>>(this.ROOT_API + '/contract-completed', lstContractIds);
  }

  public pickupContract(lstContracts: TireStoringContract[]): AxiosPromise<Response<any>> {
    return Vue.axios.post<Response<any>>(this.ROOT_API + '/pickup-list-contract', lstContracts);
  }

  public deliveryContract(tireContractDate: TireContractDate): AxiosPromise<Response<any>> {
    return Vue.axios.post<Response<any>>(this.ROOT_API + '/delivery-contract', tireContractDate);
  }

  // public autoFillPickupDate(pickupDate: string): AxiosPromise<Response<TireStoringContract[]>> {
  //   return Vue.axios.get<Response<TireStoringContract[]>>(
  //     this.ROOT_API + '/auto-fill-pickup-date/pickup-start-date/' + pickupDate);
  // }

  public setPickupDate(contractId: string, pickupDate: string): AxiosPromise<Response<TireStoringContract>> {
    return Vue.axios.post<Response<TireStoringContract>>(
      this.ROOT_API + '/set-pickup/' + contractId,
      null,
      {
        params: { date: pickupDate },
      });
  }

  public setDeliveryDate(contractId: string, deliveryDate: string): AxiosPromise<Response<TireStoringContract>> {
    return Vue.axios.post<Response<TireStoringContract>>(
      this.ROOT_API + '/set-delivery/' + contractId,
      null,
      {
        params: { date: deliveryDate },
      });
  }

  public autoSetPickup(contractIds: any[]): AxiosPromise<Response<any>> {
    return Vue.axios.post<Response<TireStoringContract>>(this.ROOT_API + '/auto-set-pickup', contractIds);
  }

  public autoSetDelivery(contractIds: any[]): AxiosPromise<Response<any>> {
    return Vue.axios.post<Response<TireStoringContract>>(this.ROOT_API + '/auto-set-delivery', contractIds);
  }

  public cancelPickup(contractIds: any[]): AxiosPromise<Response<any>> {
    return Vue.axios.post<Response<TireStoringContract>>(this.ROOT_API + '/cancel-pickup', contractIds);
  }

  public cancelDelivery(contractIds: any[]): AxiosPromise<Response<any>> {
    return Vue.axios.post<Response<TireStoringContract>>(this.ROOT_API + '/cancel-delivery', contractIds);
  }

  public getTerm(): AxiosPromise<Response<Term>> {
    return Vue.axios.get<Response<Term>>(this.ROOT_API + '/term');
  }

  public getExpiredFeeOfContract(contractId: string): AxiosPromise<Response<number>> {
    return Vue.axios.get<Response<number>>(this.ROOT_API + '/get-extension-fee/' + contractId);
  }

  public exportContract(id: string) {
    return Vue.axios.get<any>(this.ROOT_API + '/export/' + id, { responseType: 'blob' })
      .then((response) => {
        if (response.headers['x-file-name']) {
          const fileName: string = decodeURI(response.headers['x-file-name']);
          const blob = new Blob([response.data], {type: "application/pdf"});
          FileSaver.saveAs(blob, fileName);
        }
      });
  }

  public exportMultiContract(listContractId: any[]) {
    const ids = listContractId.filter((contract) => contract !== undefined).join();
    return Vue.axios.get<any>(this.ROOT_API + '/export-multi', {
        params: { listId: ids },
        responseType: 'blob',
      })
      .then((response) => {
        if (response.headers['x-file-name']) {
          const fileName: string = decodeURI(response.headers['x-file-name']);
          const blob = new Blob([response.data], {type: "application/pdf"});
          FileSaver.saveAs(blob, fileName);
        }
      });
  }

  public exportCsv(request: DataTableRequest, status: number, mode: string) {
    return Vue.axios.get<Response<any>>(this.ROOT_API + '/export-contract-list/' + status + '/' + mode, {responseType: 'blob', params: request})
      .then((response) => {
        if (response.headers['x-file-name']) {
          const fileName: string = decodeURI(response.headers['x-file-name']);
          FileSaver.saveAs(response.data, fileName);
        }
      });
  }

  public getContractUrl(contractId: string): string {
    return this.ROOT_API + '/view-contract/' + contractId;
  }

  private loadImageUrl(contract: TireStoringContract): TireStoringContract {
    if (contract.summerSeasonInfo && contract.summerSeasonInfo.tires) {
      // sort imageScratch by location
      contract.summerSeasonInfo.tires.forEach(tire => {
        tire.imageScratch.sort((image1, image2) => {
          return (image1.location > image2.location) ? 1 : -1;
        })
      })
      contract.summerSeasonInfo.tires.forEach((tire) => {
        tire.imageUrl = tire.imageId ? imageService.getImageUrl(tire.imageId) : '';
      
        tire.imageScratchUrl = tire.imageScratch ? tire.imageScratch.map(t => imageService.getImageUrl(t.id!)) : [];
      });
    }
    if (contract.winterSeasonInfo && contract.winterSeasonInfo.tires) {
      // sort imageScratch by location
      contract.winterSeasonInfo.tires.forEach(tire => {
        tire.imageScratch.sort((image1, image2) => {
          return (image1.location > image2.location) ? 1 : -1;
        })
      })
      contract.winterSeasonInfo.tires.forEach((tire) => {
        tire.imageUrl = tire.imageId ? imageService.getImageUrl(tire.imageId) : '';
        tire.imageScratchUrl = tire.imageScratch ? tire.imageScratch.map(t => imageService.getImageUrl(t.id!)) : [];
      });
    }
    return contract;
  }

  public updateLocationNo(data: TireStoringContract): AxiosPromise<Response<TireStoringContract>> {
    const request: TireStoringContract = JSON.parse(JSON.stringify(data));
    return Vue.axios.put<Response<TireStoringContract>>(this.ROOT_API + '/update-location-no', request);
  }

  public settingLocation(locationId: string, contractIds: string[]): AxiosPromise<Response<any>> {
    return Vue.axios.post<Response<any>>(this.ROOT_API + '/setting-location/' + locationId, contractIds);
  }

}
export const tireStoringContractService = new TireStoringContractService();
